import React, { useState } from "react";
import { toast } from "sonner";
import { CheckSquare, X } from "lucide-react";
import { DOSYA_DURUMLARI } from "../lib/choices";

const BULK_CONFIG = {
    "sigorta-dosyalari": {
        field: "dosya_durumu",
        label: "Dosya durumu",
        options: DOSYA_DURUMLARI,
    },
    "tahkim-dosyalari": {
        field: "dosya_durumu",
        label: "Dosya durumu",
        options: DOSYA_DURUMLARI,
    },
    "dava-dosyalari": {
        field: "dosya_durumu",
        label: "Dosya durumu",
        options: DOSYA_DURUMLARI,
    },
    icralar: {
        field: "dosya_durumu",
        label: "Durum",
        options: [
            { value: "BASLATILDI", label: "Başlatıldı" },
            { value: "TAKIPTE", label: "Takipte" },
            { value: "TAHSIL_EDILDI", label: "Tahsil Edildi" },
            { value: "KAPANDI", label: "Kapandı" },
        ],
    },
    evraklar: {
        field: "onay_durumu",
        label: "Onay durumu",
        options: [
            { value: "BEKLIYOR", label: "Bekliyor" },
            { value: "ONAYLI", label: "Onaylı" },
            { value: "REDDEDILDI", label: "Reddedildi" },
        ],
    },
};

export function supportsBulkUpdate(entityKey) {
    return Boolean(BULK_CONFIG[entityKey]);
}

export default function BulkActionBar({
    entityKey,
    resource,
    selectedIds,
    onClear,
    onDone,
    busy,
    setBusy,
}) {
    const cfg = BULK_CONFIG[entityKey];
    const [value, setValue] = useState("");

    if (!cfg || !selectedIds?.length) return null;

    async function applyBulk() {
        if (!value) {
            toast.info("Lütfen yeni durum seçin.");
            return;
        }
        setBusy(true);
        try {
            const { bulkUpdateList } = await import("../lib/api");
            const res = await bulkUpdateList(resource, {
                ids: selectedIds,
                field: cfg.field,
                value,
            });
            toast.success(`${res.updated || selectedIds.length} kayıt güncellendi`);
            onClear();
            onDone?.();
        } catch (e) {
            toast.error(
                e?.response?.data?.detail || e?.message || "Toplu güncelleme başarısız.",
            );
        } finally {
            setBusy(false);
        }
    }

    return (
        <div className="mb-4 flex flex-wrap items-center gap-2 px-3 py-2 rounded-lg border border-[#D4AF37]/30 bg-[#D4AF37]/10">
            <CheckSquare className="h-4 w-4 text-[#F3E5AB]" />
            <span className="text-sm text-[#F3E5AB] font-medium">
                {selectedIds.length} kayıt seçili
            </span>
            <select
                value={value}
                onChange={(e) => setValue(e.target.value)}
                className="h-9 px-2 rounded-md bg-[#0B0F19] border border-white/10 text-sm text-slate-200"
            >
                <option value="">— {cfg.label} —</option>
                {cfg.options.map((o) => {
                    const val = Array.isArray(o) ? o[0] : o.value;
                    const lab = Array.isArray(o) ? o[1] : o.label;
                    return (
                        <option key={val} value={val}>
                            {lab}
                        </option>
                    );
                })}
            </select>
            <button
                type="button"
                disabled={busy || !value}
                onClick={applyBulk}
                className="h-9 px-3 rounded-md bg-[#D4AF37] text-slate-900 text-xs font-bold disabled:opacity-50"
            >
                Toplu güncelle
            </button>
            <button
                type="button"
                onClick={onClear}
                className="h-9 px-2 rounded-md text-slate-400 hover:text-white inline-flex items-center gap-1 text-xs"
            >
                <X className="h-3.5 w-3.5" /> Temizle
            </button>
        </div>
    );
}
